import { render, staticRenderFns } from "./TuitionSchoolFeesForm.vue?vue&type=template&id=5c6100c0&scoped=true"
import script from "./TuitionSchoolFeesForm.vue?vue&type=script&lang=js"
export * from "./TuitionSchoolFeesForm.vue?vue&type=script&lang=js"
import style0 from "./TuitionSchoolFeesForm.vue?vue&type=style&index=0&id=5c6100c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6100c0",
  null
  
)

export default component.exports